/**
 * Dev-only logger. In production builds these calls become no-ops so we get
 * clean browser consoles for buyers while preserving actionable debug output
 * during development. Use for graceful degradation paths (caught errors that
 * are non-fatal for the UX).
 */
const isDev = process.env.NODE_ENV !== 'production';

export const logger = {
  warn: (...args) => { if (isDev) console.warn(...args); },
  error: (...args) => { if (isDev) console.error(...args); },
  info: (...args) => { if (isDev) console.info(...args); },
};
